module.exports = __webpack_public_path__ + "img/wrapbg1.3fb128a7.png";